import { render, staticRenderFns } from "./quickstock-add.vue?vue&type=template&id=f17f778a"
import script from "./quickstock-add.vue?vue&type=script&lang=ts"
export * from "./quickstock-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports